import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  homePageFaqs: [],
  homePageFaqsLoading: true,
  productPageFaqs: [],
  productPageFaqsLoading: true,
};

const faqSlice = createSlice({
  name: "faqs",
  initialState,
  reducers: {
    setHomepageFaqsInfo(state = initialState, action) {
      return {
        ...state,
        homePageFaqs: action.payload?.homePageFaqs,
        homePageFaqsLoading: action.payload?.homePageFaqsLoading,
      };
    },
    setProductPageFaqsInfo(state = initialState, action) {
      return {
        ...state,
        productPageFaqs: action.payload?.productPageFaqs,
        productPageFaqsLoading: action.payload?.productPageFaqsLoading,
      };
    },
  },
});

export const { setVehiclesInfo } = faqSlice.actions;

export default faqSlice.reducer;
